export default __webpack_public_path__ + "static/media/package-5.77c94dc9.png";